module.exports = __webpack_public_path__ + "img/icon_menu_search_main.631c8d1c.svg";